import { render, staticRenderFns } from "./motto.vue?vue&type=template&id=4eb04050&"
import script from "./motto.vue?vue&type=script&lang=js&"
export * from "./motto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports